import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import {
  DownloadQuoteLevelFilesResponseBody,
  DownloadQuoteLevelFilesRequestBody,
  DownloadQuoteLevelFilesRequestParams,
} from './types';

export const useDownloadQuoteLevelFiles: MutationFunction<
  DownloadQuoteLevelFilesResponseBody,
  DownloadQuoteLevelFilesRequestBody,
  [DownloadQuoteLevelFilesRequestParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { quoteId } = params;
  const urlPath = `/quotes/${quoteId}/download_quote_level_files`;
  const request = useRequest(requestOptions);

  return useMutation(
    ({ ...body }) => {
      return request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['quotes', quoteId, 'downloadQuoteLevelFiles'],
    },
  );
};
